// components/ResponsiveDialogContent.tsx
import * as React from "react";
import { DialogContent } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

export function ResponsiveDialogContent({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <DialogContent
      className={cn(
        // ✅ iPhone/Android: almost full screen
        "w-[calc(100vw-24px)] max-w-[calc(100vw-24px)]",
        // ✅ iPad Air / tablet: limit width + allow scroll
        "md:w-[720px] md:max-w-[720px]",
        // ✅ desktop
        "lg:w-[820px] lg:max-w-[820px]",
        // ✅ prevent content overflow on short height screens
        "max-h-[85vh] overflow-y-auto",
        // ✅ nicer spacing
        "p-0",
        className
      )}
    >
      {children}
    </DialogContent>
  );
}